// Örnek servis codiagno login
import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "/v1/foodmenu";

/**
 * FoodMenuService provides methods to interact with the food menu API.
 */
const FoodMenuService = {
  /**
   * Retrieves food menus with optional filters and pagination.
   * @param {string} [startDate=""] - The start date filter (YYYY-MM-DD).
   * @param {string} [endDate=""] - The end date filter (YYYY-MM-DD).
   * @param {number|string} [pageSize=15] - Number of items per page or "Tümü" for all.
   * @param {number} [page=1] - The page number.
   * @returns {Promise<import('axios').AxiosResponse>} Axios response promise.
   */
  getMenus(startDate = "", endDate = "", pageSize = 15, page = 1) {
    let size = pageSize;
    if (pageSize === "Tümü") {
      size = "";
    }
    return axios.get(
      `/admin/foodmenu?StartDate=${startDate}&EndDate=${endDate}&PageSize=${size}&Page=${page}`
    );
  },

  /**
   * Deletes multiple food menus.
   * @param {Object} data - Data containing menu IDs to delete.
   * @returns {Promise<import('axios').AxiosResponse>} Axios response promise.
   */
  deleteMenus(data) {
    return axios.put(`${RESOURCE_NAME}/delete/menus`, data);
  },

  /**
   * Creates a new food menu Excel file.
   * @param {FormData} formData - FormData containing the Excel file.
   * @returns {Promise<import('axios').AxiosResponse>} Axios response promise.
   */
  createNewFoodMenuExcel(formData) {
    return axios.post(`${RESOURCE_NAME}/excel`, formData, {
      contentType: "multipart/form-data",
    });
  },

  /**
   * Deletes a single food menu by ID.
   * @param {string|number} id - The ID of the food menu to delete.
   * @returns {Promise<import('axios').AxiosResponse>} Axios response promise.
   */
  deleteMenu(id) {
    return axios.delete(`${RESOURCE_NAME}/delete/${id}`);
  },

  /**
   * Updates a food menu.
   * @param {{ Id: number, IsSpecialDay: boolean, Food: [{ Type: string, FoodKind: [{ Name: string, Calory: string }] }] }} body
   * @returns {Promise<import('axios').AxiosResponse>} Axios response promise.
   */
  updateMenu(body) {
    return axios.put(`${RESOURCE_NAME}/food`, body);
  },
};

export default FoodMenuService;
